import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../../src/client/config';

const { urlRoot } = config;

const Meta = ({ title, categoryName, urlSlug, image }) => {
  const description = `Read our top Resources for ${categoryName}. Everything from cost guides, walkthroughs and how-to tutorials to assist in your everyday life, which may assist with the selection of goods and services.`;
  return (
    <Helmet>
      <title>{title} | Localsearch</title>
      <meta name="description" content={description} />
      <meta name="COPYRIGHT" content="Localsearch" />
      <meta name="AUTHOR" content="Localsearch" />
      <meta name="RESOURCE-TYPE" content="DOCUMENT" />
      <meta name="DISTRIBUTION" content="GLOBAL" />
      <meta name="RATING" content="GENERAL" />
      <meta property="og:title" content={`${title} | Localsearch`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={`${urlRoot}${urlSlug}`} />
      <meta property="og:site_name" content="Localsearch" />
      <meta property="og:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@localsearchau" />
      <meta name="twitter:title" content={`${title}  | Localsearch`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={`${urlRoot}${urlSlug}`} />
    </Helmet>
  );
};

export default Meta;
